// extracted by mini-css-extract-plugin
module.exports = {"FormatOptions":"Approve_FormatOptions__1UaBR","Header":"Approve_Header__W16-o"};